import Grid from '@mui/material/Grid';
import SectionVaccsCard2 from "./SectionVaccsCard2";
import GetVaccCounts from "./VaccsRecords/GetVaccsCounts";
import VaccsText from './VaccsText';
import { VaccsTableData } from './VaccsRecords/GetVaccs';
import SectionStructure from '../../../components/Section/SectionStructure';

export default function VaccsSection() {
   
return (
<>

    <SectionStructure
    
            sectiontext=    { <VaccsText /> }

            sectioncards=  {
            
                <Grid container direction="row" sx={{p: {xs:2, md:4, xl:0},}}>
                
                 <Grid item  xs={12} xl={6} sx={{mb:2,}}>      
                     
                     <Grid container direction="column" spacing={2} >
                        <Grid item  sx={{display: 'flex', justifyContent: 'center', alignItems: 'flex-start',}}>   <GetVaccCounts /> </Grid>
                        <Grid item  sx={{display: 'flex', justifyContent: 'center', alignItems: 'flex-start',}}>  <SectionVaccsCard2 />  </Grid>
                    </Grid>
                
                </Grid>
                
                    <Grid item xs={12} xl={5} sx={{mb:2, display: 'flex', justifyContent: 'center', alignItems: 'center',}}>  <VaccsTableData />    </Grid>
                
                </Grid>
            }
    />

{/*
<Grid container sx={{p: {xs:2, md:4, xl:12}, bgcolor: 'tertiary.light'}}>
  
  <Grid item xs={12} lg={3} sx={{p: {xs:2}, mb:{xs:4,}, display: 'flex', justifyContent: 'center', alignItems: 'flex-start',}}>  </Grid>


  <Grid item xs={12} lg={3} sx={{ml: {xs:8, lg:2}, p: {xs:2}, mb:{xs:4,}, display: 'flex', justifyContent: {xs: 'center', lg: 'flex-start'}, alignItems: 'flex-start', }}> 
      <Grid container spacing={4}>
          <Grid item>    </Grid>
          <Grid item>  </Grid>   
      </Grid>
  </Grid>

  <Grid item xs={12} lg={4} sx={{ml: {xs:8, lg:12}, mb:{xs:4,}, }}> 
     
  </Grid>

</Grid>
*/}

</>)}